import React, { useEffect, useState, useCallback } from "react";
import styled, { withTheme } from "styled-components";
import PropTypes from "prop-types";
import LabelledInput from "../../ui-library/LabelledInput/LabelledInput";
import { useTranslation } from "react-i18next";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const ActionButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 38px;
  @media (max-width: 576px) {
    padding-top: 2rem;
    margin-top: auto;
    .btn {
      width: 100%;
    }
  }
`;

const AddSite = (props) => {
  const { onSubmit, SiteButton, greenTheme, hasError } = props;

  const { t } = useTranslation();

  const [site, setSite] = useState("");
  const [error, setError] = useState(null);

  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (site.length === 3) {
      setError(null);
    }
  }, [site]);

  useEffect(() => {
    if (hasError) {
      setSubmitting(false);
    }
  }, [hasError]);

  const checkInputError = (e) => {
    setError(null);
    if (e.target.value.length < 3) {
      setError(t("errorText.addSite.site.length"));
    }
  };

  const submitForm = useCallback(() => {
    setSubmitting(true);
    onSubmit(site);
  }, [site]);

  return (
    <Container data-testid="add-new-site">
      <LabelledInput
        title={`${t("appText.nonParticipants.addSite.site")}:`}
        type="text"
        data-testid="site-input"
        placeholder="XXX"
        pattern="[0-9]{0,3}"
        value={site}
        autoFocus={true}
        onChange={(e) => e.target.validity.valid && setSite(e.target.value)}
        greenTheme={greenTheme}
        onBlur={(e) => checkInputError(e)}
        hasError={!!error}
        errorMessage={error}
      />

      {onSubmit && (
        <ActionButtonsContainer>
          <SiteButton
            data-testid="submit-button"
            onClick={submitForm}
            disabled={site.length < 3 || submitting}
          >
            {t("appText.nonParticipants.addSite.submit")}
          </SiteButton>
        </ActionButtonsContainer>
      )}
    </Container>
  );
};

AddSite.defaultProps = {
  onSubmit: null,
};

AddSite.propTypes = {
  onSubmit: PropTypes.func,
};

export default withTheme(AddSite);
